import type { NandaDiagnoseKenmerk } from '@/services';
import type { NnnKenmerkGroep } from '../types/careplan-nnn.types';

export function groupKenmerkenByCategorie(kenmerken: NandaDiagnoseKenmerk[]): NnnKenmerkGroep[] {
  const groepen = new Map<string | null, NandaDiagnoseKenmerk[]>();
  for (const kenmerk of kenmerken) {
    const categorie = kenmerk.categorie ?? null;
    const bestaand = groepen.get(categorie);
    if (bestaand) {
      bestaand.push(kenmerk);
    } else {
      groepen.set(categorie, [kenmerk]);
    }
  }
  return [...groepen.entries()].map(([categorie, items]) => ({ categorie, kenmerken: items }));
}
